var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBestPlate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "En \\u0130yi Tabak",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFD21F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A20A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bp-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B40E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp-dome",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D4DAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8590A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp-plate",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB7C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp-star",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0202E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bp-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bp-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#5C3F00",
    floodOpacity: 0.38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#5C3F00",
    opacity: 0.38,
    filter: "url(#bp-bsh)",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#A87A05",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp-face)",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#B98306",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#bp-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.55,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#bp-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bp-osh)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 350,
    rx: 150,
    ry: 28,
    fill: "#6F7A8E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 342,
    rx: 150,
    ry: 28,
    fill: "url(#bp-plate)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 336,
    rx: 128,
    ry: 18,
    fill: "#C2CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,334 A120,120 0 0 1 376,334 Z",
    fill: "url(#bp-dome)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 324,
    width: 256,
    height: 16,
    rx: 8,
    fill: "#A9B3C3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 326,
    width: 200,
    height: 5,
    rx: 2.5,
    fill: "#FFFFFF",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,304 A96,96 0 0 1 214,236",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.9,
    strokeWidth: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,224 A96,96 0 0 1 252,221",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.9,
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 204,
    width: 14,
    height: 14,
    fill: "#8590A4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 202,
    rx: 22,
    ry: 13,
    fill: "url(#bp-dome)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 198,
    rx: 9,
    ry: 4,
    fill: "#FFFFFF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(352 176) scale(44)",
    fill: "#8F1520",
    d: "M0.0,-0.88 L0.24,-0.21 L0.95,-0.19 L0.39,0.25 L0.59,0.93 L0.0,0.54 L-0.59,0.93 L-0.39,0.25 L-0.95,-0.19 L-0.24,-0.21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(352 176) scale(44)",
    fill: "url(#bp-star)",
    stroke: "#FFFFFF",
    strokeWidth: 0.09,
    strokeLinejoin: "round",
    d: "M0.0,-1.0 L0.24,-0.33 L0.95,-0.31 L0.39,0.13 L0.59,0.81 L0.0,0.42 L-0.59,0.81 L-0.39,0.13 L-0.95,-0.31 L-0.24,-0.33 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 344,
    cy: 162,
    rx: 10,
    ry: 6,
    fill: "#FFFFFF",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(150 186) scale(16)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(404 262) scale(10)",
    fill: "#FFFFFF",
    opacity: 0.9,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestPlate);
export default __webpack_public_path__ + "static/media/best-plate.5763ba7ac0fe42da240c2090009273d2.svg";
export { ForwardRef as ReactComponent };